/* eslint-env mocha
 * Menu items and subMenu items
 */
export default {
  data () {
    return {
      role: window.localStorage.getItem('role'),
      is_admin_menu_active: JSON.parse(window.localStorage.getItem('is_admin_menu_active')),
      noPaddingTop: [
        'Reviews Analytics', 'Invites', 'Conversions', 'AnalyticsTrustIndex', 'AnalyticsIndustryRanking', 'BusinessProfile', 'Homepage', 'ReviewsShare', 'Collect Reviews', 'Users',
        'API Integration'
      ], // routes names to remove top padding
      fullWidthView: ['Homepage', 'Users', 'API Integration'],
      menuItems: [
        {
          showFree: false,
          isLink: true,
          destination: '/',
          text: 'Home',
          mobileOnly: false,
          icon: `/static/img/new/menu/${imgNameByDevice('home.png')}`,
          iconSet: `/static/img/new/menu/${imgNameByDevice('home@2x.png')} 1.5x, /static/img/new/menu/${imgNameByDevice('home@2x.png')} 2x, /static/img/new/menu/${imgNameByDevice('home@3x.png')} 3x`,
          useIconAsImage: true,
          imgClass: 'home-icon-img',
          isAdminActive: false,
          businessAdminOnly: false, // whether or not this menu item should be available to Business Admins only
          permCode: [0, 0, 1, 1] // First digit->HPAdmin+BizAdmin, Second digit->HPAdmin+BizUser, Third digit->BizAdmin, Fourth digit->BizUser
        },
        {
          showFree: false,
          isLink: true,
          destination: '/reviews',
          text: 'Reply',
          showChildren: false,
          mobileOnly: false,
          // icon: 'fas fa-edit',
          icon: `/static/img/new/menu/${imgNameByDevice('reply.png')}`,
          iconSet: `/static/img/new/menu/${imgNameByDevice('reply@2x.png')} 1.5x, /static/img/new/menu/${imgNameByDevice('reply@2x.png')} 2x, /static/img/new/menu/${imgNameByDevice('reply@3x.png')} 3x`,
          useIconAsImage: true,
          imgClass: 'reply-icon-img',
          isAdminActive: false,
          businessAdminOnly: false, // whether or not this menu item should be available to Business Admins only
          permCode: [0, 0, 1, 1]
        },
        {
          showFree: false,
          isLink: true,
          destination: '/collect-reviews',
          text: 'Collect',
          mobileOnly: true,
          icon: '/static/img/new/menu/mobile_collect.png',
          iconSet: '/static/img/new/menu/mobile_collect@2x.png 1.5x, /static/img/new/menu/mobile_collect@2x.png 2x, /static/img/new/menu/mobile_collect@3x.png 3x',
          useIconAsImage: true,
          imgClass: 'collect-icon-img',
          isAdminActive: false,
          businessAdminOnly: false, // whether or not this menu item should be available to Business Admins only
          permCode: [0, 0, 1, 1] // First digit->HPAdmin+BizAdmin, Second digit->HPAdmin+BizUser, Third digit->BizAdmin, Fourth digit->BizUser
        },
        {
          isDivider: true
        },
        {
          showFree: false,
          isLink: false, // is a router link
          destination: '', // router target
          text: 'Collect', // menu label to display
          mobileOnly: false, // whether or not this menu item should be rendered for Mobile
          // icon: 'fa fa-shopping-basket', // icon to render
          icon: '/static/img/new/menu/collect.png',
          iconSet: '/static/img/new/menu/collect@2x.png 1.5x, /static/img/new/menu/collect@2x.png 2x, /static/img/new/menu/collect@3x.png 3x',
          useIconAsImage: true,
          imgClass: 'collect-icon-img',
          hideOnMobile: true,
          isAdminActive: false,
          businessAdminOnly: false, // whether or not this menu item should be available to Business Admins only
          showChildren: false,
          isParentMenu: true,
          permCode: [0, 0, 1, 1],
          slideMultiMenu: {
            'Settings': {'Email Settings': {path: '/collect-reviews/look-and-feel'}, 'Google Settings': {path: '/collect-reviews/google-reviews'}},
            'Manual Review Invites': {
              'Email and SMS Invites': {path: '/collect-reviews/email-and-sms'},
              'Landing Page Share Link': {path: '/collect-reviews/review-share?type=landingpage'},
              'WhatsApp Share Link': {path: '/collect-reviews/review-share?type=whatsapp'},
              'QR Code': {path: '/collect-reviews/review-share-qrcode'}
            },
            'History': {'Invite History': {path: '/collect-reviews/review-invites/history'}}
          },
          subMenu: [
            {
              destination: '/collect-reviews/review-invites/template',
              text: 'Review invites',
              isSubMenuActive: true,
              isAdminActive: false,
              permCode: [0, 0, 1, 1]
            },
            {
              destination: '/collect-reviews/review-share-qrcode',
              text: 'QR Codes',
              isSubMenuActive: true,
              isAdminActive: false,
              permCode: [0, 0, 1, 1]
            },
            {
              destination: '/collect-reviews/review-share',
              text: 'Review share link',
              isAdminActive: false,
              permCode: [0, 0, 1, 1]
            }
          ]
        },
        // {
        //   isLink: true, // is a router link
        //   destination: '/onsite-widgets', // router target
        //   text: 'Share', // menu label to display
        //   mobileOnly: false, // whether or not this menu item should be rendered for Mobile
        //   // icon: 'fa fa-window-restore', // icon to render
        //   icon: '/static/img/new/menu/share.png',
        //   iconSet: '/static/img/new/menu/share@2x.png 1.5x, /static/img/new/menu/share@2x.png 2x, /static/img/new/menu/share@3x.png 3x',
        //   useIconAsImage: true,
        //   hideOnMobile: true,
        //   isAdminActive: false,
        //   businessAdminOnly: false, // whether or not this menu item should be available to Business Admins only
        //   showChildren: false,
        //   isParentMenu: false,
        //   permCode: [0, 0, 1, 1]
        // },
        {
          showFree: false,
          isLink: false, // is a router link
          destination: '', // router target
          text: 'Share', // menu label to display
          // slideMenuTitle: 'Social Media',
          mobileOnly: false, // whether or not this menu item should be rendered for Mobile
          // icon: 'fab fa-facebook', // icon to render
          icon: '/static/img/new/menu/share.png',
          iconSet: '/static/img/new/menu/share@2x.png 1.5x, /static/img/new/menu/share@2x.png 2x, /static/img/new/menu/share@3x.png 3x',
          useIconAsImage: true,
          imgClass: 'share-icon-img',
          hideOnMobile: true,
          isAdminActive: false,
          businessAdminOnly: false, // whether or not this menu item should be available to Business Admins only
          showChildren: false,
          isParentMenu: true,
          permCode: [0, 0, 1, 1],
          slideMultiMenu: {
            'Display on website': {'Widgets': {path: '/onsite-widgets'}},
            'Create for social media': {'Social Posts': {path: '/ads/creator'}}/* ,
            'Social integration': { 'Facebook Tab': { path: '/fb-integration' } } */
          },
          subMenu: [
            /* {
              destination: '/fb-integration',
              text: 'Facebook Tab',
              isSubMenuActive: true,
              isAdminActive: false,
              showAlways: true,
              permCode: [0, 0, 1, 1]
            }, */
            {
              destination: '/ads/creator',
              text: 'Social Ads',
              isSubMenuActive: true,
              isAdminActive: false,
              showAlways: true,
              permCode: [0, 0, 1, 1]
            },
            {
              destination: '/onsite-widgets', // router target
              text: 'Widgets',
              isSubMenuActive: true,
              isAdminActive: false,
              showAlways: true,
              permCode: [0, 0, 1, 1]
            }
          ]
        },
        {
          showFree: false,
          isLink: false, // is a router link
          destination: '', // router target
          text: 'Insights', // menu label to display
          mobileOnly: false, // whether or not this menu item should be rendered for Mobile
          // icon: 'fas fa-chart-bar', // icon to render
          icon: '/static/img/new/menu/insights.png',
          iconSet: '/static/img/new/menu/insights@2x.png 1.5x, /static/img/new/menu/insights@2x.png 2x, /static/img/new/menu/insights@3x.png 3x',
          useIconAsImage: true,
          imgClass: 'insights-icon-img',
          hideOnMobile: true,
          isAdminActive: false,
          businessAdminOnly: false, // whether or not this menu item should be available to Business Admins only
          showChildren: false,
          isParentMenu: true,
          permCode: [0, 0, 1, 1],
          subMenu: [
            {
              destination: '/analytics/reviews/detailed-stats',
              text: 'Reviews',
              isSubMenuActive: true,
              isAdminActive: false,
              showAlways: true,
              permCode: [0, 0, 1, 1]
            },
            {
              destination: '/analytics/invites',
              text: 'Review invites',
              isSubMenuActive: true,
              isAdminActive: false,
              showAlways: true,
              permCode: [0, 0, 1, 1]
            },
            {
              destination: '/analytics/nps',
              text: 'Net promoter score',
              isSubMenuActive: true,
              isAdminActive: false,
              showAlways: true,
              permCode: [0, 0, 1, 1]
            },
            {
              destination: '/analytics/google',
              text: 'Google',
              isSubMenuActive: true,
              isAdminActive: false,
              showAlways: true,
              permCode: [0, 0, 1, 1]
            },
            {
              destination: '/analytics/competitors/trust-index',
              text: 'Competitors',
              isSubMenuActive: true,
              isAdminActive: false,
              showAlways: true,
              permCode: [0, 0, 1, 1]
            },
            {
              destination: '/analytics/trust-index-and-industry/trust-index',
              text: 'TrustIndex',
              isSubMenuActive: true,
              isAdminActive: false,
              showAlways: true,
              permCode: [0, 0, 1, 1]
            }
          ]
        },
        {
          showFree: false,
          isLink: true,
          destination: '/reviews-listing',
          text: 'All reviews',
          showChildren: false, // used to determine whether or not to show subMenu items
          mobileOnly: false,
          icon: '/static/img/new/menu/admin_icons/all-reviews@2x.png',
          iconSet: '/static/img/new/menu/admin_icons/all-reviews@2x.png 1.5x, /static/img/new/menu/admin_icons/all-reviews@2x.png 2x, /static/img/new/menu/admin_icons/all-reviews@3x.png 3x',
          useIconAsImage: true,
          imgClass: 'all-reviews-icon-img',
          isAdminActive: true,
          hpAdminOnly: true, // whether or not this menu item should be available to HP Admins only
          permCode: [1, 1, 0, 0]
        },
        {
          showFree: false,
          isLink: true,
          destination: '/sweep',
          text: 'Sweep',
          showChildren: false, // used to determine whether or not to show subMenu items
          mobileOnly: false,
          icon: '/static/img/new/menu/admin_icons/sweep@2x.png',
          iconSet: '/static/img/new/menu/admin_icons/sweep@2x.png 1.5x, /static/img/new/menu/admin_icons/sweep@2x.png 2x, /static/img/new/menu/admin_icons/sweep@3x.png 3x',
          useIconAsImage: true,
          imgClass: 'sweep-icon-img',
          isAdminActive: true,
          hpAdminOnly: true, // whether or not this menu item should be available to HP Admins only
          permCode: [1, 1, 0, 0]
        },
        {
          showFree: false,
          isLink: true,
          destination: '/spam',
          text: 'Spam',
          showChildren: false, // used to determine whether or not to show subMenu items
          mobileOnly: false,
          icon: '/static/img/new/menu/admin_icons/spam@2x.png',
          iconSet: '/static/img/new/menu/admin_icons/spam@2x.png 1.5x, /static/img/new/menu/admin_icons/spam@2x.png 2x, /static/img/new/menu/admin_icons/spam@3x.png 3x',
          useIconAsImage: true,
          imgClass: 'spam-icon-img',
          isAdminActive: true,
          hpAdminOnly: true, // whether or not this menu item should be available to HP Admins only
          permCode: [1, 1, 0, 0]
        },
        {
          showFree: false,
          isLink: true,
          destination: '/reported-review',
          text: 'Reported reviews',
          showChildren: false, // used to determine whether or not to show subMenu items
          mobileOnly: false,
          icon: '/static/img/new/menu/admin_icons/reported@2x.png',
          iconSet: '/static/img/new/menu/admin_icons/reported@2x.png 1.5x, /static/img/new/menu/admin_icons/reported@2x.png 2x, /static/img/new/menu/admin_icons/reported@3x.png 3x',
          useIconAsImage: true,
          imgClass: 'reported-icon-img',
          isAdminActive: true,
          hpAdminOnly: true, // whether or not this menu item should be available to Business Admins only
          permCode: [1, 1, 0, 0]
        },
        {
          showFree: false,
          isLink: true, // is a router link
          destination: '/businesses', // router target
          text: 'Businesses', // menu label to display
          mobileOnly: false, // whether or not this menu item should be rendered for Mobile
          icon: '/static/img/new/menu/admin_icons/businesses@2x.png',
          iconSet: '/static/img/new/menu/admin_icons/businesses@2x.png 1.5x, /static/img/new/menu/admin_icons/businesses@2x.png 2x, /static/img/new/menu/admin_icons/businesses@3x.png 3x',
          useIconAsImage: true,
          imgClass: 'businesses-icon-img',
          isAdminActive: true,
          opsOnly: true, // whether or not this menu item should be available to HP Ops only
          hpAdminOnly: true,
          permCode: [1, 1, 0, 0]
        },
        {
          showFree: false,
          isLink: true, // is a router link
          destination: '/onboard-verification', // router target
          text: 'Business verification', // menu label to display
          mobileOnly: false, // whether or not this menu item should be rendered for Mobile
          icon: '/static/img/new/menu/admin_icons/verification@2x.png',
          iconSet: '/static/img/new/menu/admin_icons/verification@2x.png 1.5x, /static/img/new/menu/admin_icons/verification@2x.png 2x, /static/img/new/menu/admin_icons/verification@3x.png 3x',
          useIconAsImage: true,
          imgClass: 'verification-icon-img',
          isAdminActive: true,
          opsOnly: true, // whether or not this menu item should be available to HP Ops only
          permCode: [1, 1, 0, 0]
        },
        {
          showFree: false,
          isLink: true, // is a router link
          destination: '/profile-management', // router target
          text: 'Profile Management', // menu label to display
          mobileOnly: false, // whether or not this menu item should be rendered for Mobile
          icon: '/static/img/new/menu/admin_icons/profile-manage@2x.png',
          iconSet: '/static/img/new/menu/admin_icons/profile-manage@2x.png 1.5x, /static/img/new/menu/admin_icons/profile-manage@2x.png 2x, /static/img/new/menu/admin_icons/profile-manage@3x.png 3x',
          useIconAsImage: true,
          imgClass: 'profile-manage-icon-img',
          isAdminActive: true,
          opsOnly: true, // whether or not this menu item should be available to HP Ops only
          permCode: [1, 1, 0, 0]
        },
        {
          showFree: false,
          isLink: true,
          destination: '/users-list',
          text: 'Users',
          showChildren: false, // used to determine whether or not to show subMenu items
          mobileOnly: false,
          icon: '/static/img/new/menu/admin_icons/users@2x.png',
          iconSet: '/static/img/new/menu/admin_icons/users@2x.png 1.5x, /static/img/new/menu/admin_icons/users@2x.png 2x, /static/img/new/menu/admin_icons/users@3x.png 3x',
          useIconAsImage: true,
          imgClass: 'users-icon-img',
          isAdminActive: true,
          hpAdminOnly: true, // whether or not this menu item should be available to Business Admins only
          permCode: [1, 1, 0, 0]
        },
        {
          showFree: true,
          isLink: false, // is a router link
          destination: '', // router target
          text: 'Billing', // menu label to display
          mobileOnly: false, // whether or not this menu item should be rendered for Mobile
          hideOnMobile: true,
          // icon: 'fas far fa-money-bill-alt', // icon to render
          icon: '/static/img/new/menu/billing.png',
          iconSet: '/static/img/new/menu/billing@2x.png 1.5x, /static/img/new/menu/billing@2x.png 2x, /static/img/new/menu/billing@3x.png 3x',
          useIconAsImage: true,
          imgClass: 'billing-icon-img',
          isAdminActive: false,
          businessAdminOnly: true, // whether or not this menu item should be available to Business Admins only
          showChildren: false,
          permCode: [1, 0, 1, 0],
          subMenu: [
            {
              destination: '/billing',
              routeName: 'BillingIndexView',
              text: 'Billing Details',
              isAdminActive: false,
              showAlways: true,
              permCode: [0, 0, 1, 0]
            },
            {
              destination: '/eft-manual-matching',
              text: 'EFT Manual Matching',
              isAdminActive: true,
              hpAdminOnly: true, // this menu item will only be available to HP hp admin
              permCode: [1, 0, 0, 0]
            },
            {
              destination: '/invoices',
              text: 'Invoices',
              isAdminActive: true,
              hpAdminOnly: true, // this menu item will only be available to HP hp admin
              permCode: [1, 0, 0, 0]
            }
          ]
        },
        {
          showFree: false,
          isLink: false, // is a router link
          destination: '', // router target
          text: 'Integration', // menu label to display
          mobileOnly: false, // whether or not this menu item should be rendered for Mobile
          // icon: '/static/img/icons/setting.svg',
          icon: '/static/img/new/menu/integration.png',
          iconSet: '/static/img/new/menu/integration@2x.png 1.5x, /static/img/new/menu/integration@2x.png 2x, /static/img/new/menu/integration@3x.png 3x',
          useIconAsImage: true,
          imgClass: 'integration-icon-img',
          hideOnMobile: true,
          isAdminActive: false,
          businessAdminOnly: false, // whether or not this menu item should be available to Business Admins only
          showChildren: false,
          isParentMenu: true,
          permCode: [0, 0, 1, 1],
          subMenu: [
            {
              destination: '/integrations/api',
              text: 'API',
              isSubMenuActive: true,
              isAdminActive: false,
              showAlways: true,
              permCode: [0, 0, 1, 1]
            }
          ]
        },
        {
          showFree: false,
          isLink: true, // is a router link
          destination: '/business/profile', // router target
          text: 'Business Settings', // menu label to display
          mobileOnly: false, // whether or not this menu item should be rendered for Mobile
          // icon: 'fas fa-suitcase', // icon to render
          icon: `/static/img/new/menu/${imgNameByDevice('settings.png')}`,
          iconSet: `/static/img/new/menu/${imgNameByDevice('settings@2x.png')} 1.5x, /static/img/new/menu/${imgNameByDevice('settings@2x.png')} 2x, /static/img/new/menu/${imgNameByDevice('settings@3x.png')} 3x`,
          useIconAsImage: true,
          imgClass: 'business-settings-icon-img',
          // borderBottom: true,  // to render horizontal line after menu
          isAdminActive: false,
          businessAdminOnly: true, // whether or not this menu item should be available to Business Admins only
          permCode: [0, 0, 1, 0]
        },
        {
          showFree: false,
          isLink: true, // is a router link
          destination: '/users', // router target
          // destination: () => {
          //   window.events.$emit('show-invite-modal')
          // },
          text: isMobile() ? 'Invite User' : 'User Management', // menu label to display
          mobileOnly: false, // whether or not this menu item should be rendered for Mobile
          // icon: 'fas fa-suitcase', // icon to render
          icon: `/static/img/new/menu/${imgNameByDevice('invite-user.png')}`,
          iconSet: `/static/img/new/menu/${imgNameByDevice('invite-user@2x.png')} 1.5x, /static/img/new/menu/${imgNameByDevice('invite-user@2x.png')} 2x, /static/img/new/menu/${imgNameByDevice('invite-user@3x.png')} 3x`,
          useIconAsImage: true,
          imgClass: 'invite-user-icon-img',
          // borderBottom: true,  // to render horizontal line after menu
          isAdminActive: false,
          businessAdminOnly: true, // whether or not this menu item should be available to Business Admins only
          permCode: [0, 0, 1, 0]
        },
        // {
        //   isLink: true,
        //   destination: '/users',
        //   text: 'User management',
        //   showChildren: false, // used to determine whether or not to show subMenu items
        //   mobileOnly: false,
        //   icon: 'fas fa-user',
        //   isAdminActive: false,
        //   businessAdminOnly: true, // whether or not this menu item should be available to Business Admins only
        //   permCode: [0, 0, 1, 0]
        // },
        {
          showFree: false,
          isLink: true,
          destination: '/profile',
          text: 'Profile',
          mobileOnly: true,
          hideOnMobile: true,
          isAdminActive: false,
          businessAdminOnly: false, // whether or not this menu item should be available to Business Admins only
          permCode: [0, 0, 1, 1]
        },
        {
          showFree: false,
          isLink: true,
          destination: '/notifications',
          text: 'Notifications',
          mobileOnly: true,
          hideOnMobile: true,
          isAdminActive: false,
          businessAdminOnly: false, // whether or not this menu item should be available to Business Admins only
          hpAdminOnly: false, // this menu item will only be available to HP hp admin
          permCode: [0, 0, 1, 1]
        },
        {
          showFree: true,
          isLink: true,
          destination: '/login',
          text: 'Sign out',
          isAdminActive: false,
          mobileOnly: true,
          hideOnMobile: true,
          businessAdminOnly: false,
          permCode: [0, 0, 1, 1]
        }
      ]
    }
  },
  computed: {
    /**
     * Calculate permission index position for logged in user
     * @returns {int}
     */
    permPos () {
      if (this.is_hp_admin && this.role === 'admin' && this.is_admin_menu_active) {
        return 0
      }

      if (this.is_hp_admin && this.role === 'user' && this.is_admin_menu_active) {
        return 1
      }

      if (this.role === 'admin') {
        return 2
      }

      if (this.role === 'user') {
        return 3
      }
    }
  }
}

const isMobile = _ => window.innerWidth < 768

const imgNameByDevice = imgName => isMobile() ? `mobile_${imgName}` : imgName



// WEBPACK FOOTER //
// ./src/mixins/menu.js